// Path: src\Components\WorldOfEports\UserProfile.jsx
import React, { useCallback, useEffect, useRef, useState } from 'react'
import BaseHome from '../Home/BaseHome'
import LevelIcon from "../../assets/images/level.png"
import Newsimg from "../../assets/images/gamenews.jpeg"
import { getTopProfiles,getFollowers } from '../../api/worldOfEsports.api';
import User from "../../assets/images/user-icon.svg"
import { url } from '../../config/url';
import ListLoader from '../Common/ListLoader';
import { Navigate, useNavigate } from 'react-router';
import { t } from 'i18next';

const WorldOfEportsUserprofile = () => {
  const [topProfileList, setTopProfileList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()
  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])

  const loadMore = async () => {
    setLoading(true)
    fetchTopProfileList()
  }

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchTopProfileList = async () => {

    try {
      const data = {
        "pagination": {
          "pageNo": currentPage,
          "recordPerPage": recordPerPage,
          "sortBy": "followers",
          "sortDirection": "desc"
        }
      };

      const res= await getTopProfiles(data)
      setLoading(false)
      if (res?.success && res?.data) {
        setTopProfileList([...topProfileList, ...res?.data])
        setTotalPages(res?.totalPages);
      }
      else {
        setTopProfileList([]);
      }
    } catch (error) {
      
      setTopProfileList([]);
      setLoading(false)
    }
  };

  const handleFollowToggle = async (profileId, isFollow, currentFollowers) => {
    const action = isFollow ? "unfollow" : "follow";
    const followingUser = profileId;

    try {
      const res = await getFollowers({
        action,
        followingUser
      });
      
      if (res?.success) {
        // Update the follower count and follow state
        setTopProfileList(prevList =>
          prevList.map(profile => {
            if (profile._id === profileId) {
              return {
                ...profile,
                isFollow: !isFollow, 
                followers: isFollow ? currentFollowers - 1 : currentFollowers + 1 // Adjust follower count
              };
            }
            return profile;
          })
        );
      }
    } catch (error) {
      console.error("Failed to toggle follow state", error);
    }
  };

  return (
    // style={{ maxHeight: "calc(100% - 11rem)", minHeight: "calc(100% - 11rem)"}} give this style into inner-wrapper
    <BaseHome isFooter={false} title={t("woe.top_profiles")} MaxFullPageScroll={false}>
      {topProfileList?.length > 0 ?
        <div className='world-of-esports-main-wrap'>
          <div className='world-of-esports-inner-wrap'>
            <div className='row'>
              {topProfileList?.length > 0 ? topProfileList.map((data, index) => (
                <div className='col-4 ps-1 pe-1' key={index} ref={topProfileList?.length === index + 1 ? lastPostElementRef : null}>
                  <div className='world-of-esports-player-profile mt-4' style={{ marginBottom: "3rem" }}>
                    <div className='world-of-esports-profile-wrap'>
                      <div className='world-of-esports-player-profile-container'>

                        {data?.level ?
                          <div className='world-of-esports-player-profile-circle' style={{cursor:"pointer"}} onClick={() => navigate('/user-profile/' + data?._id)}>
                            <img className="world-of-esport-player-img" src={url?.IMAGE_URL + data?.level} alt="Player" />
                          </div>
                          :
                          <div className='world-of-esports-player-profile-circle' style={{cursor:"pointer"}} onClick={() => navigate('/user-profile/' + data?._id)}>
                            <img className="world-of-esport-player-img" src={User} alt="Player" />
                          </div>
                        }

                        <div className='world-of-esports-player-info mt-4'>
                          <h2 className='world-of-esports-player-name mb-0 pb-0'>
                            
                          {data?.gamerjiName?.length > 13 ? (
                                      <marquee>
                                        {data?.gamerjiName}
                                      </marquee>
                                    ) : (
                                      data?.gamerjiName
                                    )}
                            {/* {data?.gamerjiName} */}
                            </h2>
                          <p className='world-of-esports-player-followers '>
  {data?.followers === 0 ? '0 follower' : data?.followers === 1 ? '1 follower' : `${data?.followers} followers`}
</p>

                        </div>
                        <button 
                      className='world-of-esports-follow-btn' 
                      onClick={() => handleFollowToggle(data._id, data?.isFollow, data.followers)}
                    >
                      {data?.isFollow ? "Following" : "Follow"}
                    </button>
                      </div>
                    </div>
                  </div>
                </div>
              )):  <> <div className='no-record-found-center' style={{width:"100%"}}><span className="text-center">no data found</span></div></>}
         
            </div>
          </div>
        </div>
        :
        !loading && <div className='w-100 d-flex justify-content-center'><span className="text-center">No data found</span></div>
      }
           {loading && <div className='w-100 d-flex justify-content-center align-items-center' style={{height:"100vh"}}> <ListLoader/></div>}
    </BaseHome>
  )
}

export default WorldOfEportsUserprofile